<template>
       <div
              class=" justify-content-around align-items-center px-5  pb-3 d-none d-lg-flex"
            >
<!--              <img-->
<!--                id="popover-target-4"-->
<!--                class="form__set form__set&#45;&#45;4"-->
<!--                src="../assets/images/pakiet_4.svg"-->
<!--                alt="pszczeli pakiet"-->
<!--              />-->
<!--              <b-popover-->
<!--                target="popover-target-4"-->
<!--                triggers="hover"-->
<!--                placement="top"-->
<!--              >-->
<!--                Książka D. Goulsona pt. Łąka-->
<!--                             </b-popover>-->
<!--          -->
<!--              <img-->
<!--                id="popover-target-3"-->
<!--                class="form__set form__set&#45;&#45;1"-->
<!--                src="../assets/images/pakiet_1.svg"-->
<!--                alt="pszczeli pakiet"-->
<!--              />-->
<!--              <b-popover-->
<!--                target="popover-target-3"-->
<!--                triggers="hover"-->
<!--                placement="top"-->
<!--              >-->
<!--                Certyfikat Pszczelego Bohatera / Bohaterki-->
<!--              </b-popover>-->

<!--              <img-->
<!--                id="popover-target-1"-->
<!--                class="form__set form__set&#45;&#45;2"-->
<!--                src="../assets/images/pakiet_2.svg"-->
<!--                alt="pszczeli pakiet"-->
<!--              />-->
<!--              <b-popover-->
<!--                target="popover-target-1"-->
<!--                triggers="hover"-->
<!--                placement="top"-->
<!--              >-->
<!--                Wygodna maseczka z kwietnym motywem, uszyta z ekologicznych tkanin przez rodzinną firmę-->
<!--              </b-popover>-->
<!--            </div>-->

</template>

<script>
export default {
  name: "Gifts",
  data() {
    return {
      title: "gifts",
    };
  },
};
</script>
